export const ADD_NEW_APPLICATION = 'ADD_NEW_APPLICATION';
export const UPDATE_APPLICATION_NAME = 'UPDATE_APPLICATION_NAME';
export const BUTTON_SELECTED = 'BUTTON_SELECTED';
export const TESTING_SAGAS = 'TESTING_SAGAS';
export const MORE_TESTING_SAGAS = 'MORE_TESTING_SAGAS';